import React, { useEffect, useState } from 'react';
import moment from 'moment';
import truncate from 'lodash/truncate';
import { Link } from 'react-router-dom';

import { meta } from '~/commons/config';
import { resolveTo } from '~/commons/helpers';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useComparable from '~/commons/hooks/useComparable';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListPagination from '~/commons/components/ListPagination.jsx';
import BtnLimit from '../btns/BtnLimit.jsx';
import BtnSort from '../btns/BtnSort.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';
import Header from '../layout/Header.jsx';

const PageThemeReportsAnnouncements = ({
  title = '最新消息',
  path,
}) => {
  const [res, req, fetched = { total: 0 }] = useHttpStatus();
  const [query, setQuery] = useState({
    skip: 0,
    sort: { publishAt: -1 },
    limit: 20,
  });
  const [dateRange, setDateRange] = useState(() => {
    // const from = moment();
    const from = moment('2024-04-01');

    // if (from.month() < 8) from.subtract(1, 'y');
    console.log('1111111111111---------', from.startOf('M').toDate());
    return {
      // from: from.month(8).startOf('M').toDate(),
      from: from.startOf('M').toDate(),
      to: moment().startOf('d').toDate(),
    };
  });

  meta.set({ title });

  useEffect(() => {
    req({
      url: 'api/site/announcements',
      params: {
        ...query,
        filter: { ...dateRange, path: 'themeReports' },
      },
    });
    console.log('useEffect---------', dateRange);
  }, [useComparable(query), useComparable(dateRange)]);

  return (
    <div>
      <Header
        bg={{
          // left: 'assets/img/header-2-left.png',
          // right: 'assets/img/header-2-right.png',
          color: '#FFF',
          // cover: 'assets/img/header-2-bg.png'
        }}
      >
        <div className="pos-abs-center bg-white px-5 py-2">
        <h1 className="m-0">
          {/* 最新消息 */}
          <div className="small-sm smaller-xs" style={{ color: '#B3C100', fontWeight: '700' }}>{ title }</div>
        </h1>
        </div>
      </Header>
      <div className="container py-4">
        {/* controls */}
        <div className="form-row justify-content-between my-3">
          <div className="col-auto">
            <div className="form-row">
              <div className="col-auto my-2">
                <ListPagination
                  size="sm"
                  {...{
                    ...query,
                    total: fetched.total,
                    onChange: (p) => setQuery({ ...query, ...p }),
                  }}
                />
              </div>
              <div className="col-auto my-2">
                <BtnDayRangePicker
                  range={dateRange}
                  onChange={setDateRange}
                />
              </div>
            </div>
          </div>
          <div className="col-auto">
            <div className="form-row">
              <div className="col-auto my-2">
                <BtnLimit query={query} onQuery={setQuery} />
              </div>
              <div className="col-auto my-2">
                <BtnSort by="publishAt" query={query} onQuery={setQuery}>
                  發布日期
                </BtnSort>
              </div>
            </div>
          </div>
        </div>
        <PageHttp res={res}>
          {({ rows }) => (
            <div className="border-top">
              {rows.map((r, i) => (
                <div
                  key={i}
                  className="border-bottom row no-gutters py-3 align-items-center"
                >
                  <div className="col-md-auto">
                    <div
                      className="d-none d-md-block square"
                      style={{ width: '140px' }}
                    >
                      <div
                        className="img-bg-cover"
                        style={{ backgroundImage: `url('${r.coverImg}')` }}
                      ></div>
                    </div>
                    <div className="d-md-none mb-4 ratio-ultrawide">
                      <div
                        className="img-bg-cover"
                        style={{ backgroundImage: `url('${r.coverImg}')` }}
                      ></div>
                    </div>
                  </div>
                  <div className="col-md px-3">
                    <h4 className="mb-3">{r.title}</h4>
                    <p className="">
                      {truncate(r.contentText, {
                        length: 40,
                        omission: '……',
                      })}
                    </p>
                    <p className="small text-muted">
                      發布日期: {moment(r.publishAt).format('LL')}
                    </p>
                  </div>
                  <div className="
                    px-3 px-md-0 text-right text-md-left col-md-auto
                  ">
                    <Link
                      to={resolveTo(r._id)}
                      className="btn btn-light px-4 py-2"
                    >
                      <span className="mr-3">
                        查看詳情
                      </span>
                      &nbsp;
                      <img
                        src={'assets/img/long-arrow-right-blk.svg'}
                        style={{ width: '38px', height: '9px' }}
                      />
                  </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </PageHttp>
      </div>
    </div>
  );
};

export default PageThemeReportsAnnouncements;
